import { useState, useEffect } from 'react';
import { api } from '../api/client';
import { parseHostContext as parseLocalHostContext } from '../utils/subdomain';

let cached = null;
let inflight = null;

async function fetchHostContext() {
  const local = parseLocalHostContext();
  if (local.portal !== null) return { ...local, isCustomDomain: false };

  const data = await api.getHostContext();
  return {
    portal: data.portal,
    companySlug: data.company_slug,
    isCustomDomain: !!data.is_custom_domain,
    company: data.company,
    portalUrls: data.portal_urls,
  };
}

export function useHostContext() {
  const [ctx, setCtx] = useState(cached || { ...parseLocalHostContext(), loading: !cached, isCustomDomain: false });

  useEffect(() => {
    if (cached) {
      setCtx({ ...cached, loading: false });
      return;
    }
    if (!inflight) {
      inflight = fetchHostContext()
        .then((data) => {
          cached = data;
          return data;
        })
        .catch(() => {
          const fallback = { ...parseLocalHostContext(), isCustomDomain: false };
          cached = fallback;
          return fallback;
        })
        .finally(() => { inflight = null; });
    }
    inflight.then((data) => setCtx({ ...data, loading: false }));
  }, []);

  return ctx;
}

export function resetHostContextCache() {
  cached = null;
}